import {
 bexoHttpClient
} from '../../clients';
import {
 BexinsightsSearchV2Response
} from './Types/Bexo.types';

/**
 * Service class for performing operations related to BeXInsights.
 */
class BeXInsightsService {

    /**
     * Searches the BeXInsights records (v2).
     * @param {string} oragID - The tenant ID for the search.
     * @param {string} appId - The application ID for the search.
     * @param {Object} payload - The search query payload.
     * @returns {Promise<Object>} The response from the server after searching the records.
     */
    async searchV2(oragID: string, appId: string, payload: object, connectionId?: string): Promise<BexinsightsSearchV2Response> {
        const response = await bexoHttpClient.post('/bexinsights/v2/search', payload, {
            params: {
                org_id: oragID,
                app_id: appId,
                ...(connectionId ? { connection_id: connectionId } : {}),
            },
            headers: {
                'Content-Type': 'application/json',
            },
        });

        return response.data;
    }
}

const bexInsightsService = new BeXInsightsService();
export { bexInsightsService };
